export const GoogleLogo = ({ className = '' }) => (
  <svg viewBox="0 0 48 48" aria-hidden="true" className={className}>
    <path fill="#EA4335" d="M24 9.5c3.1 0 5.9 1.1 8.1 3.1l6-6C34.4 3.2 29.6 1 24 1 14.6 1 6.4 6.4 2.5 14.1l7 5.4C11.2 13.3 17.1 9.5 24 9.5z" />
    <path fill="#34A853" d="M24 47c6.5 0 12-2.1 16-5.8l-7.7-6.1c-2.2 1.5-5 2.4-8.3 2.4-6.8 0-12.6-3.8-14.6-9.3l-7 5.4C6.3 41.4 14.5 47 24 47z" />
    <path fill="#4A90E2" d="M40 41.2C44.6 37 47 30.8 47 24c0-1.6-.2-3.2-.4-4.7H24v9h12.9c-.6 2.9-2.2 5.4-4.6 6.8l7.7 6.1z" />
    <path fill="#FBBC05" d="M9.4 28.2c-.5-1.4-.8-2.8-.8-4.2s.3-2.9.8-4.2l-7-5.4C.9 17.4 0 20.6 0 24s.9 6.6 2.4 9.6l7-5.4z" />
  </svg>
);

export const AppleLogo = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor">
    <path d="M16.7 12.8c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.2-2.8.8-3.6.8-.8 0-2-.8-3.2-.8-1.7 0-3.2 1-4 2.5-1.7 2.9-.4 7.2 1.2 9.6.8 1.2 1.7 2.5 3 2.4 1.2-.1 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.2-1.2 3-2.3.9-1.3 1.3-2.6 1.3-2.7-.1 0-2.5-1-2.5-4.2zM14.4 6c.6-.8 1-1.9.9-3-.9 0-2.1.7-2.8 1.4-.6.7-1.1 1.8-.9 2.9 1 .1 2.1-.6 2.8-1.3z" />
  </svg>
);
